export default class PropertyUtil {
  /**
   *
   * @param value {*}
   * @returns {boolean}
   */
  static checkIfNull(value) {
    return value === null || value === undefined;
  }

  /**
   *
   * @param value {*}
   * @returns {boolean}
   */
  static checkIfNotNull(value) {
    return !PropertyUtil.checkIfNull((value));
  }
}
